import { Component } from '@angular/core';

@Component({
  selector: 'app-print-assest-landing-page',
  templateUrl: './print-assest-landing-page.component.html',
  styleUrls: ['./print-assest-landing-page.component.scss']
})
export class PrintAssestLandingPageComponent {

}
